import { useContext } from 'react';
import { Box, FormLabel, FormControl, FormGroup, FormControlLabel, Checkbox, Button } from '@mui/material';

import { PriceGridContext } from '../../../context/PriceGridContext';
import { useAppDispatch } from '../../../app/hooks';
import { handleModal } from '../../../features/modal/modalSlice';

const Labels = () => {
  const storeDispatch = useAppDispatch();
  const { displayedInfo, setDisplayedInfo } = useContext(PriceGridContext);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayedInfo({ ...displayedInfo, [event.target.name]: event.target.checked });
  };

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        maxWidth: '100%',
      }}
    >
      <Box
        sx={{
          justifyContent: 'center',
          display: 'flex',
          marginBottom: '15px',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            marginBottom: '0px',
            marginTop: '0px',
          }}
        >
          Labels
        </h1>
      </Box>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <FormLabel component="legend">
          Select the labels that you want displayed on the unit grid card.
        </FormLabel>
        <FormGroup sx={{ '& .MuiFormControlLabel-root': { width: '100%', marginLeft: 0, justifyContent: 'flex-start' } }}>
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.unitType} onChange={handleChange} name="unitType" />}
            label="Unit Type"
          />
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.modelType} onChange={handleChange} name="modelType" />}
            label="Model Type"
          />
          <FormControlLabel control={<Checkbox checked={displayedInfo.size} onChange={handleChange} name="size" />} label="Size" />
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.exposure} onChange={handleChange} name="exposure" />}
            label="Exposure"
          />
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.basePrice} onChange={handleChange} name="basePrice" />}
            label="Base Price"
          />
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.outdoorType} onChange={handleChange} name="outdoorType" />}
            label="Outdoor Type"
          />
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.outdoorSize} onChange={handleChange} name="outdoorSize" />}
            label="Outdoor Size"
          />
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.bathrooms} onChange={handleChange} name="bathrooms" />}
            label="Bathroom"
          />
          <FormControlLabel control={<Checkbox checked={displayedInfo.unit} onChange={handleChange} name="unit" />} label="Unit" />
          <FormControlLabel control={<Checkbox checked={displayedInfo.level} onChange={handleChange} name="level" />} label="Level" />
          <FormControlLabel
            control={<Checkbox checked={displayedInfo.address} onChange={handleChange} name="address" />}
            label="Address"
          />
        </FormGroup>
      </FormControl>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <Button variant="contained" color="primary" onClick={() => storeDispatch(handleModal(false))}>
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default Labels;
